module.exports = __webpack_public_path__ + "static/media/riskFemale.4e810005.mp3";